import {Action, Catalog} from '../../../../common/types/common';
import {
    CardCommissionAccountState,
    CardCommissionAccountSummaryState,
    CommissionActFile, CommissionCardBackupCodeFile, CommissionCardFileType,
    CommissionIdentificationFile, CommissionIdentificationGroupFile
} from '../../types/mx/types';
import {CardCommissionAccountFormType} from '../../types/mx/containers';

export const GROUP_CARD_COMMISSION_ACCOUNT_SAVE_ACTION: Action = {
    name: 'GROUP_CARD_COMMISSION_ACCOUNT_SAVE_ACTION',
    action: (
        groupId: string = null,
        formType: CardCommissionAccountFormType = CardCommissionAccountFormType.CREATE_FORM_FROM_LOAN
    ) => ({
        groupId,
        formType,
        type: GROUP_CARD_COMMISSION_ACCOUNT_SAVE_ACTION.name
    })
};

export const GROUP_CARD_COMMISSION_ACCOUNT_SAVE_SUCCESS_ACTION: Action = {
    name: 'GROUP_CARD_COMMISSION_ACCOUNT_SAVE_SUCCESS_ACTION',
    action: (
        cardCommissionAccountForm: CardCommissionAccountState,
        formType: CardCommissionAccountFormType,
        commissionCardId: string
    ) => ({
        cardCommissionAccountForm,
        formType,
        commissionCardId,
        type: GROUP_CARD_COMMISSION_ACCOUNT_SAVE_SUCCESS_ACTION.name
    })
};

export const GROUP_CHANGE_CARD_NUMBER_ACTION: Action = {
    name: 'GROUP_CHANGE_CARD_NUMBER_ACTION',
    action: (cardNumber: string, error: string = null) => ({
        cardNumber, error,
        type: GROUP_CHANGE_CARD_NUMBER_ACTION.name
    })
};

export const GROUP_CHANGE_BENEFICIARY_NAME_ACTION: Action = {
    name: 'GROUP_CHANGE_BENEFICIARY_NAME_ACTION',
    action: (beneficiary: string, error: string = null) => ({
        beneficiary, error,
        type: GROUP_CHANGE_BENEFICIARY_NAME_ACTION.name
    })
};

export const GROUP_DELETE_CARD_COMMISSION_ACTION: Action = {
    name: 'GROUP_DELETE_CARD_COMMISSION_ACTION',
    action: (commissionCardId: string, deleteReason: Catalog, deleteReasonOther: string) => ({
        commissionCardId, deleteReason, deleteReasonOther,
        type: GROUP_DELETE_CARD_COMMISSION_ACTION.name
    })
};

export const GROUP_DELETE_SUCCESSFUL_CARD_COMMISSION_MX_ACTION: Action = {
    name: 'GROUP_DELETE_SUCCESSFUL_CARD_COMMISSION_MX_ACTION',
    action: (cardCommissionAccountsInfo: CardCommissionAccountSummaryState[], commissionCardId: string) => ({
        cardCommissionAccountsInfo, commissionCardId,
        type: GROUP_DELETE_SUCCESSFUL_CARD_COMMISSION_MX_ACTION.name
    })
};

export const GROUP_DROP_FILE_CC_ACT_ACTION: Action = {
    name: 'GROUP_DROP_FILE_CC_ACT_ACTION',
    action: (file: CommissionActFile, error: string = null) => ({
        file, error,
        type: GROUP_DROP_FILE_CC_ACT_ACTION.name
    })
};

export const GROUP_DROP_FILE_CC_IDENTIFICATION_ACTION: Action = {
    name: 'GROUP_DROP_FILE_CC_IDENTIFICATION_ACTION',
    action: (file: CommissionIdentificationFile, error: string = null) => ({
        file, error,
        type: GROUP_DROP_FILE_CC_IDENTIFICATION_ACTION.name
    })
};

export const GROUP_DROP_FILE_CC_IDENTIFICATION_GROUP_ACTION: Action = {
    name: 'GROUP_DROP_FILE_CC_IDENTIFICATION_GROUP_ACTION',
    action: (file: CommissionIdentificationGroupFile, error: string = null) => ({
        file, error,
        type: GROUP_DROP_FILE_CC_IDENTIFICATION_GROUP_ACTION.name
    })
};

export const GROUP_DROP_FILE_CC_CARD_BACKUP_CODE_ACTION: Action = {
    name: 'GROUP_DROP_FILE_CC_CARD_BACKUP_CODE_ACTION',
    action: (file: CommissionCardBackupCodeFile, error: string = null) => ({
        file, error,
        type: GROUP_DROP_FILE_CC_CARD_BACKUP_CODE_ACTION.name
    })
};

export const GROUP_DELETE_FILE_CC_REQUEST_ACTION: Action = {
    name: 'GROUP_DELETE_FILE_CC_REQUEST_ACTION',
    action: (fileId: string, fileType, error: string = null) => ({
        fileId, fileType, error,
        type: GROUP_DELETE_FILE_CC_REQUEST_ACTION.name
    })
};
